// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { get } from 'lodash';

import Img from 'web-ssr/app/common/components/Img';
import 'web-ssr/app/services/components/ServiceLogo.scss';

import type { ServiceImageSize } from 'web-ssr/app/services/types';
import type { ServiceImages } from 'web-ssr/app/model/ServiceImages';

const bem = bemify('service-logo');

type Props = {
  size: ServiceImageSize,
  images: ServiceImages,
  serviceName: string,
  className?: string,
  format?: string,
  background?: string,
};

const sizeMap = {
  large: '128x128',
  medium: '64x64',
};

const ServiceLogo = (props: Props) => {
  const { images, size, serviceName, className, format, background } = props;
  const pixelSize = sizeMap[size];
  const imageSource: string = get(images, [`url_${pixelSize}`]);

  return (
    <Img
      alt={serviceName}
      background={background}
      className={bem(className, toModifiers(size))}
      enableThrottle={false}
      format={format}
      src={imageSource}
    />
  );
};

ServiceLogo.defaultProps = {
  size: 'medium',
};

export default ServiceLogo;
